var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("table", { staticStyle: { width: "80%" } }, [
      _c("tr", [
        _c("td", [
          _c("table", [
            _c("tr", [
              _c("td", [
                _c("div", { staticStyle: { float: "left" } }, [
                  _c("h1", [_vm._v(_vm._s(_vm.translateWords.title))])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c(
                "td",
                { staticStyle: { padding: "10px" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: _vm.translateWords.keyword },
                    model: {
                      value: _vm.keyword,
                      callback: function($$v) {
                        _vm.keyword = $$v
                      },
                      expression: "keyword"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "td",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.query } },
                    [_vm._v(_vm._s(_vm.translateWords.query))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "td",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.OpenPL } },
                    [_vm._v(_vm._s(_vm.translateWords.batchInput))]
                  )
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "el-table",
                {
                  ref: "tableData",
                  staticStyle: { width: "75%" },
                  attrs: { data: _vm.tableData, "row-key": _vm.getRowKeys }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      type: "selection",
                      "reserve-selection": true,
                      width: "55"
                    }
                  }),
                  _vm._v(" "),
                  false
                    ? _c("el-table-column", {
                        attrs: { prop: "Goods_Id", label: "Id", width: "1" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "Goods_Name2",
                      label: _vm.translateWords.ProductName,
                      width: "200"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      width: "200",
                      prop: "BarCode",
                      label: _vm.translateWords.ProductCode
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      width: "200",
                      prop: "Goods_BigClass",
                      label: _vm.translateWords.ProductType
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      width: "200",
                      prop: "Goods_Code",
                      label: _vm.translateWords.GoodsCode
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      width: "200",
                      prop: "DesignedForName",
                      label: _vm.translateWords.DesignedForName
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      width: "200",
                      prop: "Goods_Size1",
                      label: _vm.translateWords.GoodsSize
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      width: "200",
                      prop: "Unit",
                      label: _vm.translateWords.Unit
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      width: "200",
                      prop: "ExpectedShipmentDateTime",
                      label: _vm.translateWords.ExpectedShipmentDateTime
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      width: "200",
                      prop: "ExpectedArrivalDateTime",
                      label: _vm.translateWords.ExpectedArrivalDateTime
                    }
                  }),
                  _vm._v(" "),
                  false
                    ? _c("el-table-column", {
                        attrs: { width: "200", prop: "IsBig" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  false
                    ? _c("el-table-column", {
                        attrs: { width: "200", prop: "Status" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  false
                    ? _c("el-table-column", {
                        attrs: { width: "200", prop: "ImgType" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  false
                    ? _c("el-table-column", {
                        attrs: {
                          width: "200",
                          prop: "IsRequestByProductCenter"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  false
                    ? _c("el-table-column", {
                        attrs: { width: "200", prop: "IsRequestByMultimedia" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  false
                    ? _c("el-table-column", {
                        attrs: {
                          width: "200",
                          prop: "ExpectedShipmentDateTime"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  false
                    ? _c("el-table-column", {
                        attrs: { width: "200", prop: "SumStorage" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  false
                    ? _c("el-table-column", {
                        attrs: { width: "200", prop: "PositionId" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  false
                    ? _c("el-table-column", {
                        attrs: { width: "200", prop: "RackId" }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("tr"),
      _vm._v(" "),
      _c("tr", [
        _c("td", [
          _c(
            "div",
            { staticStyle: { float: "left" } },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.currPage,
                  "page-sizes": [10, 20, 30],
                  "page-size": _vm.pageSize,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.total
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange
                }
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("tr", [
        _c(
          "td",
          [
            _c(
              "el-button",
              {
                attrs: { type: "primary" },
                on: {
                  click: function($event) {
                    return _vm.tijiao()
                  }
                }
              },
              [_vm._v("提交")]
            )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1c5825e1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c5825e1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GetSampleFromAGBS.vue
// module id = null
// module chunks = 